import { Suspense, lazy } from "react";
import { BrowserRouter, Link, Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.min.css";
import { Navbar } from "./components/index.js";
import Login from "./views/Login.jsx";
import ProtectorRoute from "./views/ProtectorRoute.jsx";
import { AuthProvider } from "./views/AuthContext.jsx";

const InvoiceGenerator = lazy(() =>
  import("./views/invoice-generator/invoice-generator")
);
const InvoiceList = lazy(() => import("./views/invoice-list/invoice-list"));
const Settings = lazy(() => import("./views/settings/settings"));
const Customers = lazy(() => import("./views/customers/customers"));
const Products = lazy(() => import("./views/products/products"));

const PageLoader = () => (
  <div className="d-flex justify-content-center align-items-center py-5">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

const NotFound = () => (
  <div className="mm-empty py-5">
    <i className="bi bi-signpost-split" />
    <h1 className="h3 fw-bold">Page not found</h1>
    <p>The page you are looking for doesn't exist.</p>
    <Link to="/" className="btn btn-primary">Go to invoices</Link>
  </div>
);

const protect = (el) => <ProtectorRoute>{el}</ProtectorRoute>;

const Shell = () => {
  const { pathname } = useLocation();
  const isLogin = pathname === "/login";

  return (
    <>
      {!isLogin && <Navbar />}
      <div className={isLogin ? "" : "container-xxl px-3 px-md-4 pb-5"}>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={protect(<InvoiceGenerator />)} />
            <Route path="/invoices" element={protect(<InvoiceList />)} />
            <Route path="/customers" element={protect(<Customers />)} />
            <Route path="/products" element={protect(<Products />)} />
            <Route path="/settings" element={protect(<Settings />)} />
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </div>
      <ToastContainer autoClose={2500} position="top-right" newestOnTop />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
